import type { ChatMessage } from '../hooks/useChatStore';
import type { Message } from '../types/types.ts';

export function toChatMessages(messages: Message[]): {
  messages: ChatMessage[];
  isPending: boolean;
} {
  const isPending = messages.at(-1)?.status === 'PENDING';
  const chatMessages: ChatMessage[] = messages
    .filter((m) => m.status !== 'PENDING')
    .map((m) => ({
      id: m.id,
      role: m.role,
      text: m.text,
      status: m.status,
      errorCode: m.errorCode ?? undefined,
    }));

  return { messages: chatMessages, isPending };
}
